import { CalendarIcon, NeedHelp, PlusIcon } from "../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import DashboardTemplate from "../../../templates/Dashboard";
import PotentialDealsHeader from "../../../atoms/PotentialDealsHeader";
import { Button, Card, Checkbox, Col, DatePicker, Row, Steps } from "antd";
import TimeIcon from "../../../atoms/CustomIcons/TimeIcon";
import CheckIcon from "../../../atoms/CustomIcons/CheckIcon";
import SendIcon from "../../../atoms/CustomIcons/SendIcon";
import CheckFull from "../../../atoms/CustomIcons/CheckFull";
import EyeFull from "../../../atoms/CustomIcons/EyeFull";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getPotentialDealDetails } from "../ducks/actions";
import DealsSidebar from "../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import ProposalCards from "./ProposalCards";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

export default function DealsDetail() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const dealId = pathSegments[pathSegments.length - 2];
  const [checklistDates, setChecklistDates] = useState<{
    [key: string]: Date | null;
  }>({
    estimate: null,
    approval: null,
    send: null,
    win: null,
  });
  const dealsDetailData = useAppSelector(
    (state) => state?.potentialDeal?.dealsDetailData
  );

  const { Step } = Steps;

  const handleChecklistDateChange = (key: string) => (date: Dayjs | null) => {
    setChecklistDates((prev) => ({
      ...prev,
      [key]: date ? date.toDate() : null,
    }));
  };

  useEffect(() => {
    if (dealId) {
      dispatch(getPotentialDealDetails(dealId));
    }
  }, [dispatch, dealId]);

  useEffect(() => {
    if (dealsDetailData?.data) {
      if (dealsDetailData?.data?.status === "in_progress") {
        setCurrent(0);
      }
      if (dealsDetailData?.data?.status === "approval_pending") {
        setCurrent(1);
      }
      if (dealsDetailData?.data?.status === "ready") {
        setCurrent(2);
      }
      if (dealsDetailData?.data?.status === "sent") {
        setCurrent(3);
      }
      if (dealsDetailData?.data?.status === "accepted") {
        setCurrent(4);
      }
    }
  }, [dealsDetailData?.data]);

  return (
    <DashboardTemplate loading={loading || dealsDetailData?.loader}>
      <PotentialDealsHeader
        breadcrumb={[
          { label: "Potential deals", href: `/potential-deals/${companyId}` },
          { label: dealsDetailData?.data?.name ?? "" },
        ]}
        title={dealsDetailData?.data?.name ?? ""}
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
        propertyName={dealsDetailData?.data?.property?.name ?? ""}
        propertyClientName={dealsDetailData?.data?.property?.client?.name ?? ""}
      />

      <div className="deal_detail">
        <Row gutter={16} wrap={false}>
          <Col flex="auto" className="left_area">
            <div className="dealsLeftWrapper">
              <Card className="proposalCard">
                <div className="stepper_box">
                  <div className="stepper" style={{ marginBottom: "16px" }}>
                    <Steps className="custom-steps" current={current}>
                      <Step
                        className="step-1"
                        title={current === 0 ? "In progress" : ""}
                        icon={<TimeIcon />}
                      />
                      <Step
                        className="step-2"
                        title={current === 1 ? "Pending approval" : ""}
                        icon={<EyeFull />}
                      />
                      <Step
                        className="step-3"
                        title={current === 2 ? "Ready" : ""}
                        icon={<CheckIcon />}
                      />
                      <Step
                        className="step-4"
                        title={current === 3 ? "Sent" : ""}
                        icon={<SendIcon />}
                      />
                      <Step
                        className="step-5"
                        title={current === 4 ? "Accepted" : ""}
                        icon={<CheckFull />}
                      />
                    </Steps>
                  </div>

                  <div className="stepper_content">
                    <h3>
                      Proposals
                      <Button
                        type="primary"
                        className="outlined-btn"
                        onClick={() =>
                          navigate(`/estimate/${dealId}/${companyId}`)
                        }
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "8px",
                          padding: "0px",
                        }}
                      >
                        <PlusIcon style={{ color: "#151718" }} />
                      </Button>
                    </h3>

                    <ProposalCards
                      setLoading={setLoading}
                      loading={loading}
                      dealsDetailData={dealsDetailData?.data}
                    />
                  </div>
                </div>
              </Card>

              <Card className="checklistCardWrapper">
                <div className="checklist">
                  <div className="title">
                    <h3>Checklist</h3>
                  </div>
                  <div className="content">
                    <Card className="checklistCard">
                      <div className="checkList_listing">
                        <Checkbox>Complete estimate</Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("estimate")}
                            value={
                              checklistDates.estimate
                                ? dayjs(checklistDates.estimate)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.estimate
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_1.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="checkList_listing">
                        <Checkbox>Approve estimate & proposal</Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("approval")}
                            value={
                              checklistDates.approval
                                ? dayjs(checklistDates.approval)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.approval
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_2.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="checkList_listing">
                        <Checkbox> Send proposal </Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("send")}
                            value={
                              checklistDates.send
                                ? dayjs(checklistDates.send)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.send
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_1.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="checkList_listing">
                        <Checkbox> Win contract </Checkbox>

                        <div className="checklistFooter">
                          <DatePicker
                            onChange={handleChecklistDateChange("win")}
                            value={
                              checklistDates.win
                                ? dayjs(checklistDates.win)
                                : null
                            }
                            format={"ddd, MMM DD"}
                            allowClear={false}
                            suffixIcon={<CalendarIcon />}
                            className={
                              checklistDates.win
                                ? "checklistDatePicker"
                                : "noDateSelected"
                            }
                          />
                          <div style={{ marginLeft: 8 }}>
                            <img
                              src="/images/dummy/checkList_dp_1.png"
                              alt=""
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </Card>
            </div>
          </Col>

          <DealsSidebar sidebarData={dealsDetailData?.data} />
        </Row>
      </div>
    </DashboardTemplate>
  );
}
